(() => {
  const modal = document.getElementById('sm-recent');
  if (!modal || typeof modal.showModal !== 'function') return;
  const launcher = document.getElementById('sm-recent-launcher');
  const teaser = document.getElementById('sm-recent-teaser');
  if (!launcher || !teaser) return;
  const root = modal.dataset.root || '/';
  const grid = modal.querySelector('.sm-recent-grid');
  const status = modal.querySelector('.sm-recent-status');
  let hideTimer, previousFocus, loaded = false, loading;
  const hold = () => {};
  const hideLauncher = () => { clearTimeout(hideTimer); teaser.classList.remove('is-visible'); teaser.inert = true; };
  teaser.querySelector('.sm-recent-teaser-close').addEventListener('click', hideLauncher);
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !modal.open) hideLauncher(); });
  const close = () => { modal.close(); };
  modal.querySelector('.sm-recent-close').addEventListener('click', close);
  modal.addEventListener('close', () => {
    launcher.setAttribute('aria-expanded','false');
    document.documentElement.classList.remove('sm-recent-modal-open');
    if (previousFocus?.isConnected && previousFocus !== launcher) previousFocus.focus({preventScroll:true});
  });
  const text = (tag, className, value) => { const el = document.createElement(tag); el.className = className; el.textContent = value; return el; };
  const withPreview = path => { const u = new URL(path, location.origin); const params = new URLSearchParams(location.search); if (params.has('preview_theme_id')) u.searchParams.set('preview_theme_id', params.get('preview_theme_id')); return u; };
  const productFeed = (async () => {
    const url = withPreview(root + 'collections/all');
    url.searchParams.set('view', 'sm-recent-products');
    url.searchParams.set('sort_by', 'created-descending');
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const data = await response.json();
      if (!Array.isArray(data.products) || !data.products.length) return null;
      const previews = launcher.querySelector('.sm-recent-teaser-products');
      for (const product of data.products.slice(0,5)) {
        const item = text('span', 'sm-recent-teaser-product', '');
        const image = document.createElement('img');
        image.src = product.image; image.alt = ''; image.width = 120; image.height = 120; image.decoding = 'async';
        item.append(image, text('span', 'sm-recent-teaser-name', product.shortTitle || product.title));
        previews.append(item);
      }
      return data;
    } catch (_) { return null; }
  })();
  async function add(product, button) {
    hold(); button.disabled = true; button.textContent = modal.dataset.adding; status.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:product.variant,quantity:1}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || modal.dataset.error);
      button.textContent = modal.dataset.added;
      status.textContent = product.title + ' — ' + modal.dataset.added;
      try {
        const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          modal.querySelector('.sm-recent-count').textContent = '(' + cart.item_count + ')';
          document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
        }
      } catch (_) {}
      setTimeout(() => { button.disabled = false; button.textContent = modal.dataset.add; }, 1300);
    } catch (error) { status.textContent = error.message || modal.dataset.error; button.disabled = false; button.textContent = modal.dataset.add; }
  }
  async function init() {
    status.textContent = modal.dataset.loading;
    try {
      const data = await productFeed;
      if (!data) throw new Error('Product feed unavailable');
      for (const product of data.products.slice(0,5)) {
        const card = text('article','sm-recent-card','');
        card.dataset.smViewProduct = String(product.id);
        const link = document.createElement('a'); link.href = withPreview(product.url);
        const image = document.createElement('img'); image.src = product.image; image.alt = product.title; image.width = 240; image.height = 240; image.loading = 'eager'; image.decoding = 'async';
        link.append(image, text('h3','',product.shortTitle || product.title));
        const price = text('p','sm-recent-price',(product.varies ? modal.dataset.from + ' ' : '') + product.price + (product.stock ? ' · ' + product.stock : ''));
        const action = text(product.direct ? 'button' : 'a','sm-recent-action',product.direct ? modal.dataset.add : modal.dataset.choose);
        if (product.direct) { action.type = 'button'; action.addEventListener('click', () => add(product, action)); }
        else action.href = withPreview(product.url);
        card.append(link,price,action); grid.append(card);
      }
      loaded = true;
      status.textContent = '';
    } catch (_) { status.textContent = modal.dataset.error; }
  }
  launcher.addEventListener('click', () => {
    clearTimeout(hideTimer);
    previousFocus = document.activeElement;
    hideLauncher();
    if (modal.open) return;
    modal.showModal();
    modal.scrollTop = 0;
    launcher.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('sm-recent-modal-open');
    if (!loaded && !loading) loading = init().finally(() => { loading = null; });
  });
  function schedule() {
    setTimeout(async () => {
      const data = await productFeed;
      if (!data) return;
      if (document.hidden || document.querySelector('dialog[open]')) return;
      teaser.hidden = false;
      teaser.inert = false;
      requestAnimationFrame(() => teaser.classList.add('is-visible'));
      hideTimer = setTimeout(hideLauncher,5000);
    },1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
})();
